// function toggleSubscriptionWidget() {
//     const options = document.querySelectorAll('.ot-dingdoong-header__radio-label');
//     const widget = document.querySelector('#appstle_subscription_widget0');

//     if (!options.length || !widget) return;

//     let isShipActive = false;

//     options.forEach(option => {
//         if (
//             option.innerText.includes('Ship to me') &&
//             option.classList.contains('checked')
//         ) {
//             isShipActive = true;
//         }
//     });

//     widget.style.display = isShipActive ? 'block' : 'none';
// }
// const observer = new MutationObserver(() => {
//     toggleSubscriptionWidget();
// });
// observer.observe(document.body, {
//     childList: true,
//     subtree: true
// });
// document.body.addEventListener('click', () => {
//     setTimeout(toggleSubscriptionWidget, 100);
// });



/* Start Onload Ship To Me Select */

/*function ship(){
  document.querySelector('.ot-dingdoong-header .ot-dingdoong-header__radio div:last-child .ot-dingdoong-header__radio-label').click();  
}
 setTimeout(() => {
   ship();
 }, 500);

 setTimeout(() => {
   ship();
 }, 1000);

 setTimeout(() => {
   ship();
 }, 1500);

 setTimeout(() => {
   ship();
 }, 2000);

 setTimeout(() => {
   ship();
 }, 2500);

 setTimeout(() => {
   ship();
 }, 3000);*/

/* End Onload Ship To Me Select */

function attachListeners() {
  document.querySelectorAll('.ot-dingdoong-header__radio .ot-dingdoong-header__radio-label')
    .forEach(function(element) {

      // prevent duplicate event binding
      if (element.dataset.listenerAdded) return;
      element.dataset.listenerAdded = "true";

      element.addEventListener('click', function() {
        var text = this.querySelector('.ot-dingdoong-header__radio-label-text').textContent;
        console.log(text);

        var wrapper = document.querySelector('.appstle_subscription_wrapper');
        if (!wrapper) return;

        if (text === 'Ship to me') {
          wrapper.style.display = 'flex';
        } else {
          wrapper.style.display = 'none';
        }
      });
    });
}

// Run immediately on page load
document.addEventListener('DOMContentLoaded', function () {
  attachListeners();

  // Then keep checking every 1 sec for dynamic elements
  setInterval(function () {
    attachListeners();
  }, 1000);
});

// document.querySelectorAll('.ot-dingdoong-header__radio .ot-dingdoong-header__radio-label')
//   .forEach(function(element) {
//     element.addEventListener('click', function() {
//       var text = this.querySelector('.ot-dingdoong-header__radio-label-text').textContent;
//       console.log(text);
//         if(text == 'Ship to me') {    document.querySelector('.appstle_subscription_wrapper').style.display = 'flex';
//         } else {    document.querySelector('.appstle_subscription_wrapper').style.display = 'none';
//         }
//     });
//   });